import React, { useEffect, useState } from 'react';
import { openWhatsApp, WA_MAIN } from '../mock';

const DEFAULT_MESSAGE = 'Hola, quisiera hacer una consulta legal.';

const FloatingWhatsApp = ({ phone = WA_MAIN, message = DEFAULT_MESSAGE, label = 'floating-button' }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 450);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    openWhatsApp(phone, message, label);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`floating-whatsapp-btn ${scrolled ? '' : 'floating-whatsapp-top'}`}
      aria-label="Escribinos por WhatsApp"
      data-action="whatsapp-click"
      data-wa-label="floating-button"
      data-testid="floating-whatsapp-btn"
    >
      {/* Inline WhatsApp icon (keeps bundle small, no extra dep) */}
      <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
        className="floating-whatsapp-icon"
      >
        <path
          fill="currentColor"
          d="M19.11 17.21c-.3-.15-1.77-.87-2.04-.97s-.47-.15-.67.15-.77.97-.95 1.17-.35.22-.65.07c-.3-.15-1.27-.47-2.42-1.49-.89-.79-1.5-1.77-1.67-2.07s-.02-.46.13-.6c.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52s-.67-1.62-.92-2.22c-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.5s1.07 2.9 1.22 3.1c.15.2 2.1 3.2 5.1 4.5.71.3 1.26.47 1.69.6.71.22 1.36.19 1.87.11.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35zM16.04 5C9.9 5 4.9 10 4.9 16.15c0 1.96.52 3.88 1.5 5.56L4.76 27l5.47-1.43a11.08 11.08 0 0 0 5.81 1.57h.01c6.14 0 11.14-5 11.14-11.15 0-2.98-1.16-5.78-3.26-7.89A11.07 11.07 0 0 0 16.04 5zm0 20.3h-.01a9.26 9.26 0 0 1-4.72-1.3l-.34-.2-3.55.93.95-3.46-.22-.36a9.3 9.3 0 0 1-1.42-4.93c0-5.13 4.17-9.3 9.31-9.3 2.49 0 4.83.97 6.58 2.73a9.26 9.26 0 0 1 2.72 6.58c0 5.13-4.17 9.3-9.3 9.3z"
        />
      </svg>
      <span className="floating-whatsapp-label">WhatsApp</span>
    </button>
  );
};

export default FloatingWhatsApp;
